import axios from 'axios';

import { config } from '@/config';
import { globalLogout } from '@/context/globalLogout';

import { Configuration } from './generated/MNT';
import { interceptBackgroundTask } from './interceptors/backgroundTask';

export const apiConfig = new Configuration({
  basePath: config.API_URL + '/api',
});

export const client = axios.create({ baseURL: config.API_URL });
client.interceptors.response.use(interceptBackgroundTask);
client.interceptors.response.use(
  response => response,
  error => {
    const shouldReThrowError =
      !axios.isAxiosError(error)
      || error.response?.status != 401
      || !apiConfig.accessToken
      // A 401 from any /oauth/authorize* call is the login flow's own signal
      // (bad credentials, MFA code required/invalid) — the Login page handles it.
      || error.config?.url?.includes('/oauth/authorize');
    if (shouldReThrowError) {
      throw error;
    }

    console.warn('Got HTTP 401, logging out and redirecting to login page', error);
    globalLogout.logout();
    window.location.href = '/login?next=' + encodeURIComponent(window.location.pathname + window.location.search);
    throw error;
  },
);

// Each API client lives in its own module under api/clients, so a page only loads the generated
// classes it calls (the full generated client is about 390 kB). Import them from there, not from here.
